import { AlertTriangle } from "lucide-react";
import { trpc } from "../lib/trpc";

export default function OutageBanner() {
  const { data } = trpc.health.check.useQuery(undefined, { refetchInterval: 60_000 });
  if (!data) return null;
  if (data.ok) return null;
  return (
    <div className="flex items-center justify-center gap-2 bg-rose-600/90 px-4 py-2 text-center text-sm font-medium text-white">
      <AlertTriangle size={16} />
      <span>
        Sync is stale — last successful sync was{" "}
        {data.lastSyncAt ? new Date(data.lastSyncAt).toLocaleTimeString() : "unknown"}. Numbers may not be current.
      </span>
    </div>
  );
}
